<script>
import { Pie } from 'vue-chartjs'
import 'chartjs-plugin-colorschemes';
import chartjsPluginDatalabels from 'chartjs-plugin-datalabels'
import { FINANCE_SUMMARY_LABELS, financeSummaryChartValues } from '../utils/finance-summary'

export default {
    name: 'PieChart',
    extends: Pie,
    props: {
        summary: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            chartData: {
                labels: FINANCE_SUMMARY_LABELS,
                datasets: [{
                    label: "sample",
                    data: financeSummaryChartValues(this.summary),
                    fill: true,
                    datalabels: {
                        formatter: (value) => {
                            return `${value.toLocaleString()}円`
                        },
                        anchor: 'end'
                    }
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true
                },
                plugins: {
                    colorschemes: {
                        scheme: 'tableau.Tableau20'
                    },
                    datalabels: {
                        font: {
                            weight: 'regular'
                        }
                    }
                }
            }
        }
    },
    mounted: function() {
        this.addPlugin(chartjsPluginDatalabels)
        this.renderChart(this.chartData, this.options)
    }
}
</script>
